import React from 'react'
import RemitanceSnippet from './RemitanceSnippet'
import WithdrawalSnippet from './WithdrawalSnippet'
import GoalReportSnippet from './GoalReportSnippet'
import SurveySnippet from './SurveySnippet'
import DiagnosticianSnippet from './DiagnosticianSnippet'

const NEW_STATE = 'new'

const Notification = ({ notification }) => {
  if (!notification) return null

  const unread = notification.state === NEW_STATE

  switch (notification.referenceType) {
    case 'Remittance':
      return (
        <RemitanceSnippet
          notificationId={notification.id}
          referenceId={notification.referenceId}
          data={notification.data.remittance}
          unread={unread}
        />
      )
    case 'GoalReport':
      return (
        <GoalReportSnippet
          notificationId={notification.id}
          referenceId={notification.referenceId}
          data={notification.data}
          unread={unread}
        />
      )
    case 'Withdrawal':
      return (
        <WithdrawalSnippet
          notificationId={notification.id}
          referenceId={notification.referenceId}
          data={notification.data}
          unread={unread}
        />
      )
    case 'Survey':
      return (
        <SurveySnippet
          notificationId={notification.id}
          referenceId={notification.referenceId}
          data={notification.data}
          unread={unread}
        />
      )
    case 'CertifiedDiagnostician':
      return (
        <DiagnosticianSnippet
          notificationId={notification.id}
          referenceId={notification.referenceId}
          data={notification.data}
          unread={unread}
        />
      )
    default:
      return null
  }
}

export default Notification
